import $ from "jquery";

$(function () {
  // Variables to hold selected filters (single value per category)
  let selectedLocation = "";
  let selectedSector = "";
  let selectedStatus = "";
  let selectedType = "";

  const ajaxUrl =
    typeof wasInvestment !== "undefined" && wasInvestment.ajaxUrl
      ? wasInvestment.ajaxUrl
      : "/wp-admin/admin-ajax.php";

  // Function to load sites
  function loadSites({
    page,
    location,
    sector,
    status,
    type,
    replace = false,
  }) {
    const $grid = $(".js-sites-grid");
    const $loadMoreBtn = $(".js-sites-load");

    if (replace) {
      $grid.css("opacity", 0);
    } else {
      $grid.css("opacity", 0.5);
    }

    location = location ?? "";
    sector = sector ?? "";
    status = status ?? "";
    type = type ?? "";
    let data = {
      action: "get_sites",
      page: page || 1,
      location,
      sector,
      status,
      type,
    };

    // If no result found output message
    $grid.find(".no-result").remove();

    $.ajax({
      url: ajaxUrl,
      method: "GET",
      data: data,

      beforeSend: function () {
        $("#loader").show();
      },
      success: function (res) {
        if (res.success) {
          setTimeout(function () {
            if (replace) {
              $grid.html(res.html);
            } else {
              $grid.append(res.html);
            }
            if (res.load_more) {
              $grid.attr("data-page", res.next_page);
              $loadMoreBtn.show();
            } else {
              $loadMoreBtn.hide();
            }
            $("#loader").hide();
            $grid.css("opacity", 1);
          }, 250);
        } else {
          $("#loader").hide();
          $grid.css("opacity", 1);
          $grid.html(
            "<div class='col-start-2 text-md text-center lg:text-xl '>No sites found. Try a different filter</div>",
          );
        }
      },
    });
  }

  // Update dropdown button label and URL for a filter type
  function setDropdownLabel(filterType, value, labelText) {
    const $section = $(".js-sites-filters-section");
    const $dropdown = $section
      .find(".js-dropdown")
      .has(`.js-dropdown__link.${filterType}`);
    if ($dropdown.length) {
      const defaultTitle = $dropdown
        .find(".js-dropdown__btn")
        .attr("data-title");
      $dropdown
        .find(".js-dropdown__btn span")
        .text(labelText || defaultTitle || filterType);
    }
    const params = new URLSearchParams(window.location.search);
    if (value) params.set(filterType, value);
    else params.delete(filterType);
    const newUrl = params.toString()
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname;
    window.history.replaceState({}, "", newUrl);
  }

  // Apply initial filter state from URL or data attributes
  function initFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const $header = $("header");
    const $filters = $(".js-sites-filters-section");

    if (
      params.get("location") ||
      params.get("sector") ||
      params.get("status") ||
      params.get("type")
    ) {
      setTimeout(() => {
        window.scrollTo({
          top: $filters.offset().top - $header.height(),
          behavior: "smooth",
        });
      }, 100);
    }

    const $section = $(".js-sites-filters-section");
    selectedLocation =
      params.get("location") ||
      ($section.length ? $section.attr("data-initial-location") || "" : "");
    selectedSector =
      params.get("sector") ||
      ($section.length ? $section.attr("data-initial-sector") || "" : "");
    selectedStatus =
      params.get("status") ||
      ($section.length ? $section.attr("data-initial-status") || "" : "");
    selectedType =
      params.get("type") ||
      ($section.length ? $section.attr("data-initial-type") || "" : "");
    $(".js-dropdown__link").removeClass("active");
    $(".js-dropdown__btn").each(function () {
      const defaultTitle = $(this).attr("data-title");
      $(this).find("span").text(defaultTitle);
    });

    if (selectedLocation) {
      const $link = $(
        `.js-dropdown__link.location[data-location="${selectedLocation}"]`,
      );
      if ($link.length) {
        $link.addClass("active");
        setDropdownLabel("location", selectedLocation, $link.text().trim());
      }
    }
    if (selectedSector) {
      const $link = $(
        `.js-dropdown__link.sector[data-sector="${selectedSector}"]`,
      );
      if ($link.length) {
        $link.addClass("active");
        setDropdownLabel("sector", selectedSector, $link.text().trim());
      }
    }
    if (selectedStatus) {
      const $link = $(
        `.js-dropdown__link.status[data-status="${selectedStatus}"]`,
      );
      if ($link.length) {
        $link.addClass("active");
        setDropdownLabel("status", selectedStatus, $link.text().trim());
      }
    }
    if (selectedType) {
      const $link = $(`.js-dropdown__link.type[data-type="${selectedType}"]`);
      if ($link.length) {
        $link.addClass("active");
        setDropdownLabel("type", selectedType, $link.text().trim());
      }
    }
  }

  initFiltersFromUrl();

  // Event handlers for filter clicks
  $(".js-dropdown__link.location").on("click", function (e) {
    e.preventDefault();
    const locationValue = $(this).data("location");
    selectedLocation = locationValue;
    setDropdownLabel("location", locationValue, $(this).text().trim());
    const filters = loadFilters();
    filters.replace = true;
    loadSites(filters);
  });

  $(".js-dropdown__link.sector").on("click", function (e) {
    e.preventDefault();
    const sectorValue = $(this).data("sector");
    selectedSector = sectorValue;
    setDropdownLabel("sector", sectorValue, $(this).text().trim());
    const filters = loadFilters();
    filters.replace = true;
    loadSites(filters);
  });

  $(".js-dropdown__link.status").on("click", function (e) {
    e.preventDefault();
    const statusValue = $(this).data("status");
    selectedStatus = statusValue;
    setDropdownLabel("status", statusValue, $(this).text().trim());
    const filters = loadFilters();
    filters.replace = true;
    loadSites(filters);
  });

  $(".js-dropdown__link.type").on("click", function (e) {
    e.preventDefault();
    const typeValue = $(this).data("type");
    selectedType = typeValue;
    setDropdownLabel("type", typeValue, $(this).text().trim());
    const filters = loadFilters();
    filters.replace = true;
    loadSites(filters);
  });

  $(".js-dropdown__clear").on("click", function (e) {
    e.preventDefault();
    selectedLocation = "";
    selectedSector = "";
    selectedStatus = "";
    selectedType = "";
    $(".js-dropdown__link").removeClass("active");
    $(".js-dropdown__btn").each(function () {
      const defaultTitle = $(this).attr("data-title");
      $(this).find("span").text(defaultTitle);
    });
    window.history.replaceState({}, "", window.location.pathname);
    loadSites({
      page: 1,
      location: "",
      sector: "",
      status: "",
      type: "",
      replace: true,
    });
  });

  // Load more button
  $(".js-sites-load").on("click", function () {
    const filters = loadFilters();
    filters.page = $(".js-sites-grid").attr("data-page") || 2;
    loadSites(filters);
  });

  // Function to return selected filters
  function loadFilters() {
    const page = 1;
    return {
      page,
      location: selectedLocation,
      sector: selectedSector,
      status: selectedStatus,
      type: selectedType,
    };
  }
});
